import { ASSIGNMENT_STATUSES } from '../skill-quests-mastery-constants';

/**
 * CONSTANTS
 */
export const TOGGLE_TYPES = {
    ACCURACY: 'Accuracy',
    PROGRESS: 'Progress'
};

export const DEFAULT_VALUES = {
    PUBLICATION: 'null-publication',
    COURSES: 'null-course'
};

export const STUDENT_REPORT_LEVELS = {
    COURSE: 'COURSE',
    STRAND: 'STRAND',
    STANDARD: 'STANDARD',
    TOPIC: 'TOPIC'
};

/**
 * TABLE HELPERS
 */
export const getCourseKey = (course) =>
    `[${STUDENT_REPORT_LEVELS.COURSE}-${course.courseId}-${course.courseVersion}]`;
export const getStrandKey = (strand) =>
    `[${STUDENT_REPORT_LEVELS.STRAND}-${strand.name}]`;
export const getStandardKey = (standard) =>
    `[${STUDENT_REPORT_LEVELS.STANDARD}-${standard.id}]`;

const manageStandardTableProperties = (
    tableProperties,
    courseKey,
    strandId,
    isExpanded
) => {
    const returnedStandardProperties = {};

    Object.keys(tableProperties[courseKey].subLevel[strandId].subLevel).forEach(
        (standardId) => {
            returnedStandardProperties[standardId] = {
                isExpanded
            };
        }
    );

    return returnedStandardProperties;
};

const manageStrandProperties = (
    tableProperties,
    courseKey,
    isExpanded,
    updatedStrandId = null
) => {
    const returnedStrandProperties = {};

    Object.keys(tableProperties[courseKey].subLevel).forEach((strandId) => {
        if (!updatedStrandId || updatedStrandId === strandId) {
            returnedStrandProperties[strandId] = {
                isExpanded,
                subLevel: manageStandardTableProperties(
                    tableProperties,
                    courseKey,
                    strandId,
                    isExpanded
                )
            };
        }
    });

    return returnedStrandProperties;
};

/**
 * COLLAPSE/EXPAND STATE MANAGEMENT
 */
const getIsExpandedByStatus = (status) => {
    const { IN_PROGRESS, COMPLETED } = ASSIGNMENT_STATUSES;

    return status === IN_PROGRESS || status === COMPLETED;
};

const getIsExpandedByStandard = (standards) => {
    let isExpanded = false;

    standards.every((item) => {
        if (getIsExpandedByStatus(item.status)) {
            isExpanded = true;
            return false;
        }

        return true;
    });

    return isExpanded;
};

export const getInitialTableProperties = (data) => {
    const updatedTableProperties = {};

    if (data && data.reportData) {
        data.reportData.courses.forEach((course) => {
            const courseKey = getCourseKey(course);
            updatedTableProperties[courseKey] = {
                isExpanded: true,
                subLevel: {}
            };

            course.strands.forEach((strand) => {
                const strandKey = getStrandKey(strand);

                updatedTableProperties[courseKey].subLevel[strandKey] = {
                    isExpanded: getIsExpandedByStandard(strand.standards),
                    subLevel: {}
                };

                strand.standards.forEach((standard) => {
                    const standardKey = getStandardKey(standard);

                    updatedTableProperties[courseKey].subLevel[
                        strandKey
                    ].subLevel[standardKey] = {
                        isExpanded: getIsExpandedByStatus(standard.status)
                    };
                });
            });
        });
    }

    return updatedTableProperties;
};

export const getUpdatedCourseLevelState = (tableProperties, courseKey) => {
    const isCourseExpanded = !tableProperties[courseKey].isExpanded;

    return {
        isExpanded: isCourseExpanded,
        subLevel: manageStrandProperties(
            tableProperties,
            courseKey,
            isCourseExpanded
        )
    };
};

export const getUpdatedStrandLevelState = (
    tableProperties,
    courseKey,
    strandKey
) => {
    const isStrandExpanded = !tableProperties[courseKey].subLevel[strandKey]
        .isExpanded;

    return {
        isExpanded: isStrandExpanded,
        subLevel: manageStandardTableProperties(
            tableProperties,
            courseKey,
            strandKey,
            isStrandExpanded
        )
    };
};

export const getUpdatedStandardLevelState = (
    tableProperties,
    courseKey,
    strandKey,
    standardKey
) => {
    const isStandardExpanded = !tableProperties[courseKey].subLevel[strandKey]
        .subLevel[standardKey].isExpanded;

    return {
        isExpanded: isStandardExpanded
    };
};

export const hasValidCourses = (skillQuestsMasteryStudentData) =>
    skillQuestsMasteryStudentData &&
    skillQuestsMasteryStudentData.reportData &&
    skillQuestsMasteryStudentData.reportData.courses.length > 0;



// WEBPACK FOOTER //
// ./containers/skill-quests-mastery/student/student-helpers.js